module.exports = __webpack_public_path__ + "static/hero@2x-bdc6f8a4feed90724669efec93ca635c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/financial-services/hero@2x.jpg
// module id = 2631
// module chunks = 47877783677342